<template>
  <!-- 文字 泛红 跟读 -->
  <div class="literal-reading">
    <div class="literal-reading-box">
      <div class="literal-reading-scroll">
        <div class="literal-reading-content">
          <p>{{ listData.steps_title }}</p>
          <div id="zimu">
            <template v-for="(item, index) in lyricjson">
              <span class="word-item" @dblclick.prevent.stop="repeatAudio(item)" :key="index">
                <br v-if="item.isp == 1 && index != 0" />
                <em
                  v-if="item.isp == 1"
                  v-html="'&nbsp;&nbsp;&nbsp;&nbsp;'"
                ></em>
                <em
                  :class="{
                    isReading:
                      item.endtime / 1000 >= readCurrentTime &&
                      readCurrentTime >= item.timeslist[wordIndex] / 1000,
                  }"
                  v-for="(wordItem, wordIndex) in item.word"
                  :key="wordIndex"
                  v-html="wordItem"
                ></em>
              </span>
            </template>
            <p></p>
          </div>
        </div>
      </div>
      <div class="fun-btns">
        <em
          class="btn btn-play"
          :class="{
            'pause-btn': plsyStatus == 'paused',
            'play-btn': plsyStatus == 'play',
          }"
        ></em>
        <!-- <em class="btn pause-btn"></em> -->
        <em class="btn replay-btn"></em>
      </div>
    </div>
    <audio ref="literalReadAudio">
      <source :src="listData.steps_mp3url" />
      <source :src="listData.steps_oggurl" />
    </audio>
  </div>
</template>
<script>
export default {
  name: "LiteralReading",
  props: ["listData"],
  data() {
    return {
      plsyStatus: "play",
      readCurrentTime: 0,
      lyricjson: [],
    };
  },
  created() {
    this.lyricjson = [...this.listData.steps_lyricjson];
    this.lyricjson.forEach((e1, i1) => {
      e1.timeslist = [];
      e1.timeslist.push(Number(e1.starttime));
      e1.wordtims.forEach((e2, i2) => {
        let time = 0;
        for (let index = 0; index <= i2; index++) {
          time += Number(e1.wordtims[index]);
        }
        time += Number(e1.starttime);
        e1.timeslist.push(time);
      });
    });
    console.log(this.lyricjson, "this.lyricjson");
  },
  methods: {
    changeType() {
      this.$emit("changeType");
    },
    repeatAudio (v) {
      let { starttime } = v
      console.log(starttime/1000)
      this.$refs["literalReadAudio"].currentTime = starttime/1000
      this.$refs["literalReadAudio"].play()
    }
  },
  mounted() {
    this.$nextTick(() => {
      let audio = this.$refs["literalReadAudio"];
      console.log(audio);

      audio.addEventListener(
        "load",
        () => {
          console.log("load");
        },
        false
      );
      audio.addEventListener(
        "play",
        () => {
          console.log("play");
          this.plsyStatus = "paused";
        },
        false
      );
      audio.addEventListener(
        "pause",
        () => {
          console.log("pause");
          this.plsyStatus = "play";
        },
        false
      );

      audio.addEventListener(
        "timeupdate",
        (e) => {
          this.readCurrentTime = e.target.currentTime;
        },
        false
      );

      audio.addEventListener(
        "loadedmetadata",
        (e) => {
          console.log("loadedmetadata", e.target.duration);
        },
        false
      );

      audio.addEventListener(
        "ended",
        (e) => {
          console.log("ended");
          this.changeType();
        },
        false
      );

      let btn = document.querySelector(".fun-btns .btn-play");
      let replay = document.querySelector(".fun-btns .replay-btn");
      btn.addEventListener(
        "click",
        function() {
          if (!audio.paused) {
            audio.pause();
          } else {
            audio.play();
          }
        },
        false
      );
      replay.addEventListener(
        "click",
        function() {
          audio.currentTime = 0;
          audio.play();
        },
        false
      );
    });
  },
};
</script>
<style lang="less">
.literal-reading {
  .literal-reading-box {
    padding-top: 20px;
    position: relative;
  }
  .literal-reading-scroll {
    height: 100%;
    padding: 0 20px !important;
  }
  #zimu {
    user-select: none;
    p {
      text-align: left;
    }
    .word-item {
      font-size: 18px;
      color: rgba(102, 102, 102, 1);
      line-height: 30px;
      cursor: pointer;

      .isReading {
        color: red;
      }
    }
  }
  .fun-btns {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
